<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h1 class="header-text">Manage Propulsion Types</h1>
  <div>
    <button (click)="updatePropulsionType()" [disabled]="selectedValue===undefined" class="action-button"
            color="primary"
            id="edit-button"
            mat-stroked-button>
      Update
    </button>
    <button (click)="addPropulsionType()" [disabled]="!initialLoad || noData" class="action-button" color="primary"
            id="add-button"
            mat-raised-button>
      Add
    </button>
    <button (click)="deletePropulsionType()" [disabled]="selectedValue===undefined" class="action-button"
            color="warn"
            id="delete-button"
            mat-raised-button>
      Delete
    </button>
  </div>
</div>
<!-- Display message if there is no data -->
<div [hidden]="!noData">No Propulsion Types</div>

<!-- Display table if there is data -->
<div class="gfs-table">

  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="propulsionTypes"
    [columnDefs]="columnHeaders"
    [autoSizeStrategy]="autoSizeStrategy"
    [rowSelection]="rowSelection"
    (rowSelected)="onSelect($event)"
  />
</div>
